// extracted by mini-css-extract-plugin
export default {"counterBox":"Counter_counterBox__+kuoe","counter":"Counter_counter__myMFs","item":"Counter_item__i50io","number":"Counter_number__SlaRd","text":"Counter_text__qnBWV"};